export enum ERouteDisclaimerMessage {
  REFERRAL_PROGRAM_RESTRICTION = 'referralProgramRestriction',
  FREE_COINS_RESTRICTION = 'freeCoinsRestriction',
  SOCIAL_REWARDS_RESTRICTION = 'socialRewardsRestriction',
  BIRTHDAY_CLUB_RESTRICTION = 'birthdayClubRestriction',
  SELLING_COINS_RESTRICTION = 'sellingCoinsRestriction',
  SELL_COINS_RESTRICTION = 'sellCoinsRestriction',
  SELL_COINS_WIDGET_RESTRICTION = 'sellCoinsWidgetRestriction',
  LOYALTY_WIDGET_RESTRICTION = 'loyaltyWidgetRestriction',
  DISCOUNTS_AND_CUPONS_RESTRICTION = 'discountsAndCuponsRestriction',
  SPECIAL_COIN_OFFERS_RESTRICTION = 'specialCoinOffersRestriction',
  ACTIVATION_EMAILS_RESTRICTION = 'activationEmailsRestriction',
  CUSTOMER_IMPORT_RESTRICTION = 'customerImportRestriction',
  CUSTOMER_IMPORT_RESTRICTION_WIX_SHOPIFY_BIGCOMMERCE_WOOCOMMERCE = 'customerImportRestrictionWixShopifyBigcommerceWoocommerce'
}
